// data quality of the last calculation: which inputs were missing, estimated or taken from the terrain model
const ROWS = [
  ['zMiss', 'bad'], ['tankMiss', 'warn'], ['srcDef', 'warn'], ['pumpDef', 'warn'], ['unknownValves', 'warn'], ['hydSmall', 'warn'], ['svcSmall', 'warn'], ['distSmall', 'warn'], ['dDef', 'warn'], ['dEst', 'info'], ['cDef', 'info'], ['depthDef', 'info'], ['demDef', 'info'], ['zDem', 'info'], ['drafts', 'info'],
];
export function AquaQuality({ t, q, names }) {
  if (!q) return null;
  const rows = ROWS.map(([k, lvl]) => [k, lvl, q[k] || []]).filter(([, , l]) => l.length);
  return (
    <div className="aq-qual" data-testid="aq-quality">
      <b>{t.aqQualTitle}</b>
      {!rows.length && !q.openEnds && <p className="aq-q-ok" data-testid="aq-quality-ok">✔ {t.aqQualOk}</p>}
      {rows.map(([k, lvl, l]) => (
        <p key={k} className={`aq-q-${lvl}`} data-testid={`aq-q-${k}`}>
          <i>{lvl === 'bad' ? '✖' : lvl === 'warn' ? '⚠' : 'ℹ'}</i> {t['aqQ_' + k].replace('{n}', l.length)}
          {names && <small> {l.slice(0, 6).map(names).join(', ')}{l.length > 6 ? ' …' : ''}</small>}
        </p>
      ))}
      {q.openEnds > 0 && <p className="aq-q-info" data-testid="aq-q-openEnds"><i>ℹ</i> {t.aqQ_openEnds.replace('{n}', q.openEnds)}</p>}
    </div>
  );
}
